export enum ChartsActionTypes {
  setSelected = '[Lane] [Charts] Set selected option',
  setOptions = '[Lane] [Charts] Add options',
}
